import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    defaultMessage:
      'Create custom packages to use in addition to standard carrier packaging. These custom packages will be available to your users when shipping.',
    id: 'lf+SiR',
    description: 'settings.packages-page.custom-packages.description',
  },
  'add-custom-package-label': {
    defaultMessage: 'Add Custom Package',
    id: '7ps9/T',
    description: 'settings.packages-page.custom-packages.add-custom-package-label',
  },
  'custom-packages': {
    defaultMessage: 'Custom Packages',
    id: '2dYpaq',
    description: 'settings.packages-page.table.header',
  },
  cm: {
    defaultMessage: 'cm',
    id: '5RxaU2',
    description: 'settings.packages-page.custom-packages.dimension-input.centimeters',
  },
  in: {
    defaultMessage: 'in',
    id: 'E3aYOv',
    description: 'settings.packages-page.custom-packages.dimension-input.inches',
  },
  oz: {
    defaultMessage: 'oz',
    id: '6rDE4T',
    description: 'settings.packages-page.custom-packages.weight-unit.ounces',
  },
  lbs: {
    defaultMessage: 'lbs',
    id: '5iALMQ',
    description: 'settings.packages-page.custom-packages.weight-unit.pounds',
  },
  g: {
    defaultMessage: 'g',
    id: 'UFBXRa',
    description: 'settings.packages-page.custom-packages.weight-unit.grams',
  },
  kg: {
    defaultMessage: 'kg',
    id: 'adcmoq',
    description: 'settings.packages-page.custom-packages.weight-unit.kilograms',
  },
  'error-saving-package': {
    defaultMessage: 'An error occurred while saving the package',
    id: 'p8DvFD',
    description: 'settings.packages-page.custom-packages.error.generic-save-error',
  },
});

export const tableMessages = {
  header: defineMessages({
    title: {
      defaultMessage: 'Custom Packages',
      id: 'BOs1xy',
      description: 'settings.packages-page.custom-packages.table.title',
    },
    add: {
      defaultMessage: 'Add Custom Package',
      id: 'o82YkG',
      description: 'settings.packages-page.custom-packages.table.action.add',
    },
  }),
  headers: defineMessages({
    name: {
      defaultMessage: 'Name',
      id: 'Klobzg',
      description: 'settings.packages-page.custom-packages.table.header1',
    },
    length: {
      defaultMessage: 'Length',
      id: 'a10758',
      description: 'settings.packages-page.custom-packages.table.header2',
    },
    width: {
      defaultMessage: 'Width',
      id: 'Po1icd',
      description: 'settings.packages-page.custom-packages.table.header3',
    },
    height: {
      defaultMessage: 'Height',
      id: 'BXrr0I',
      description: 'settings.packages-page.custom-packages.table.header4',
    },
    tareWeight: {
      defaultMessage: 'Tare Weight',
      id: '5mvBQr',
      description: 'settings.packages-page.custom-packages.table.header.tare-weight',
    },
    maxWeight: {
      defaultMessage: 'Max Weight',
      id: 'cywMoL',
      description: 'settings.packages-page.custom-packages.table.header.max-weight',
    },
  }),
  actions: defineMessages({
    edit: {
      defaultMessage: 'Edit',
      id: 'p/XKCG',
      description: 'settings.packages-page.custom-packages.table.action.edit',
    },
    delete: {
      defaultMessage: 'Delete',
      id: 'YZQe9Y',
      description: 'settings.packages-page.custom-packages.table.action.delete',
    },
  }),
};
